// extracted by mini-css-extract-plugin
export default {"wrapper":"FormikTextInput_wrapper__1eR04","error":"FormikTextInput_error__nAtMM","input":"FormikTextInput_input__1CnF1","white":"FormikTextInput_white__fqWFe"};